import React, { useState } from "react";
import FooterInfoLinks from "./footer-info-links";
import FooterDocumentLinks from "./footer-document-links";

import { StyledContainer } from "../styles/styled-container";
import { StyledFooter, StyledFooterContent } from "./styled-footer";
import CookieMessage from "../cookie-message/cookie-message.component";
import Cookies from "js-cookie";
import FooterComponentContact from "./footer.component-contact";
import FooterComponentAuthor from "./footer.component-author";
import FooterComponentAbout from "./footer.component-about";
import FooterCryptoLinks from "./footer-crypto-links";

const Footer = ({ theme }) => {
  const initialCookies = {
    strictlyNecessary: true,
    functional: false,
    performance: false,
    targeting: false,
    agree: false
  };
  const [cookie, setCookie] = useState(initialCookies);

  if (Cookies.get("useCookiesConsent")) {
    const savedConsent = JSON.parse(Cookies.get("useCookiesConsent"));

    const consentUpdate = {
      ad_storage: savedConsent.targeting ? "granted" : "denied",
      analytics_storage: savedConsent.performance ? "granted" : "denied",
      personalization_storage: savedConsent.targeting ? "granted" : "denied",
      functionality_storage: savedConsent.functional ? "granted" : "denied",
      security_storage: savedConsent.strictlyNecessary ? "granted" : "denied"
    };

    window?.gtag && window.gtag("consent", "update", consentUpdate);
    window.dataLayer?.push({
      event: "consent_updated"
    });
  }

  return (
    <StyledFooter>
      {!Cookies.get("useCookiesConsent") && <CookieMessage cookie={cookie} setCookie={setCookie} />}
      <StyledContainer wrapper="content">
        <StyledFooterContent>
          <FooterComponentAbout />
          <div className="links-wrapper">
            <div className="links-block-wrapper">
              <FooterCryptoLinks />
              <FooterInfoLinks />
              <FooterDocumentLinks />
              <FooterComponentContact theme={theme} />
            </div>
          </div>
        </StyledFooterContent>
        <FooterComponentAuthor />
      </StyledContainer>
    </StyledFooter>
  );
};

export default Footer;